import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography'
import RadioGroup from '@material-ui/core/RadioGroup'
import Box from '@material-ui/core/Box';
import SideStyle from '../style/sideStyle';
import { GreyRadio } from '../style/customUI';
import Param from '../store/param';
import Control from '../store/control';
import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const Type = () => {
  const type     = Control.Get('type');

  switch(type) {
    case '':
      return <SelectType/>;
    default:
      return null;
  }
}
export default Type;


const SelectType = () => {
  const style           = SideStyle();
  const setParam        = Param.Get('setParam');
  const type            = Control.Get('type');
  const prosthetics     = Control.Get('prosthetics');
  const setControl      = Control.Get('setControl');

  const [checked, setChecked] = useState(false);

  const onChangeType = (e) => {
    console.log(e.target.name, e.target.value);
    setControl(s => {s[e.target.name] = e.target.value});
  };

  const handleCheck = (e) => {
    setChecked(e.target.checked);
    setParam(s => {s.setup.ai = e.target.checked})
  };

  return (
    <div>
      <Box className={style.moduleTitle}>Device Type</Box>
      
      <div className={style.outside}>
        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <Typography variant="h6">Prosthetic Leg</Typography>
        </Grid>

        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <FormControl component="fieldset">
            <RadioGroup aria-label="prosthetics" name="prosthetics" value={prosthetics} onChange={onChangeType} row >
              <FormControlLabel value="BK" control={<GreyRadio/>} label="Below Knee"/>
              <FormControlLabel value="AK" control={<GreyRadio/>} label="Above Knee"/>
            </RadioGroup>
          </FormControl>
        </Grid>

        <Box mt={2} /> {/* Adds margin-top space */}

        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <Typography variant="h6">Prosthetic Arm</Typography>
        </Grid>
        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <FormControl component="fieldset">
            <RadioGroup aria-label="prosthetics" name="prosthetics" value={prosthetics} onChange={onChangeType} row >
              <FormControlLabel disabled value="BE" control={<GreyRadio/>} label="Below Elbow"/>
              <FormControlLabel disabled value="AE" control={<GreyRadio/>} label="Above Elbow"/>
            </RadioGroup>
          </FormControl>
        </Grid>

        <Box mt={2} /> {/* Adds margin-top space */}

        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <Typography variant="h6">Orthosis</Typography>
        </Grid>
        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <FormControl component="fieldset">
            <RadioGroup aria-label="prosthetics" name="prosthetics" value={prosthetics} onChange={onChangeType} row >
              <FormControlLabel disabled value="LLO" control={<GreyRadio/>} label="Lower Limb Orthosis"/>
            </RadioGroup>
          </FormControl>
        </Grid>

        {(prosthetics == 'BK') &&
        <FormControl fullWidth>
          <InputLabel>Select Type</InputLabel>
          <Select
            type='number'
            name='type'
            defaultValue={type}
            value={type}
            onChange={onChangeType}
          >
            <MenuItem value='TestSocket'>Test Socket</MenuItem>
            <MenuItem value='FinalDevice'>Final Device</MenuItem>
            <MenuItem value='FinalDeviceFinalStep' disabled>Final Device - Final Step Only</MenuItem>
            <MenuItem value='SoftInsert'>Soft Insert</MenuItem>
            <MenuItem value='CosmeticCover' disabled >Cosmetic Cover</MenuItem>
          </Select>
        </FormControl>
        }

        {(prosthetics == 'AK') &&
        <FormControl fullWidth>
          <InputLabel>Select Type</InputLabel>
          <Select
            type='number'
            name='type'
            defaultValue={type}
            value={type}
            onChange={onChangeType}
          >
            <MenuItem value='TestSocket'>Test Socket</MenuItem>
            <MenuItem value='FinalDevice'>Final Device</MenuItem>
            <MenuItem value='SoftInsert'>Soft Insert</MenuItem>
            <MenuItem value='CosmeticCover' disabled >Cosmetic Cover</MenuItem>
          </Select>
        </FormControl>
        }

        {(prosthetics == 'LLO') &&
        <FormControl fullWidth>
          <InputLabel>Select Type</InputLabel>
          <Select
            type='number'
            name='type'
            defaultValue={type}
            value={type}
            onChange={onChangeType}
          >
            <MenuItem value='AFO' disabled>AFO</MenuItem>
            <MenuItem value='KAFO' disabled>KAFO</MenuItem>
          </Select>
        </FormControl>
        }


      </div>
    </div>
  );
}

